import actionTypes from "../actionTypes";

const gamesInitial = { loading: false, entities: [] };

export function games(state = gamesInitial, action) {
  switch (action.type) {
    case actionTypes.GAMES_REQUEST: {
      return { ...state, loading: true };
    } case actionTypes.GAMES_SUCCESS: {
      return { loading: false, entities: action.value };
    } case actionTypes.GAMES_FAIL: {
      return { ...state, loading: false };
    } default:
      return state;
  }
}

const bettingGamesInitial = { loading: false, entities: [] };

export function bettingGames(state = bettingGamesInitial, action) {
  switch (action.type) {
    case actionTypes.BETTING_GAMES_SUCCESS: {
      return { loading: false, entities: action.value };
    } case actionTypes.BETTING_GAMES_FAIL: {
      return { ...state, loading: false };
    } default:
      return state;
  }
}

const liveCasinoGamesInitial = { loading: false, entities: [] };

export function liveCasinoGames(state = liveCasinoGamesInitial, action) {
  switch (action.type) {
    case actionTypes.LIVECASINO_GAMES_SUCCESS: {
      return { loading: false, entities: action.value };
    } case actionTypes.LIVECASINO_GAMES_FAIL: {
      return { ...state, loading: false };
    } default:
      return state;
  }
}

const tournamentsInitial = [];

export function tournaments(state = tournamentsInitial, action) {
  switch (action.type) {
    case actionTypes.TOURNAMENTS_SUCCESS:
      return action.value;
    case actionTypes.SET_TOURNAMENT:
      return { ...state, selected: action.selected};
    case actionTypes.TOURNAMENT_CASINO_REGISTER_SUCCESS:
    case actionTypes.TOURNAMENT_CASINO_UNREGISTER_SUCCESS:
      return state.map(t => t.tournamentId === action.value.tournamentId ? action.value : t);
    case actionTypes.USER_LOGOUT:
      return tournamentsInitial;
    default:
      return state;
  }
}

const tournamentsCasinoInitial = { selected: '' };

export function tournamentsCasino(state = tournamentsCasinoInitial, action) {
  switch (action.type) {
    case actionTypes.SELECT_TOURNAMENT:
      return { ...state, selected: action.selected};
    case actionTypes.USER_LOGOUT:
      return tournamentsCasinoInitial;
    default:
      return state;
  }
}

export function tournamentPlayers(state = {}, action) {
  switch (action.type) {
    case actionTypes.TOURNAMENT_PLAYER_UPDATE: {
      const { id, players } = action;
      return {
        ...state,
        [id]: players,
      };
    } default:
      return state;
  }
}

const providersInitial = { loading: false, entities: [] };

export function providers(state = providersInitial, action) {
  switch (action.type) {
    case actionTypes.PROVIDERS_REQUEST: {
      return { ...state, loading: true };
    } case actionTypes.PROVIDERS_SUCCESS: {
      return { loading: false, entities: action.value };
    } case actionTypes.PROVIDERS_FAIL: {
      return { ...state, loading: false };
    } default:
      return state;
  }
}

const productsTypesInitial = { loading: false, entities: [] };

export function productsTypes(state = productsTypesInitial, action) {
  switch (action.type) {
    case actionTypes.PRODUCTS_TYPES_REQUEST: {
      return { ...state, loading: true };
    } case actionTypes.PRODUCTS_TYPES_SUCCESS: {
      return { loading: false, entities: action.value };
    } case actionTypes.PRODUCTS_TYPES_FAIL: {
      return { ...state, loading: false };
    } default:
      return state;
  }
}

export function gameTags(state = [], action) {
  switch (action.type) {
    case actionTypes.GAME_TAGS_SUCCESS: {
      return action.value;
    }
    default:
      return state;
  }
}

const gameCategoriesInitial = { selected: 'regular', list: [] };
export function gameCategories(state = gameCategoriesInitial, action) {
  switch (action.type) {
    case actionTypes.GAME_CATEGORIES_SUCCESS: {
      return { selected: state.selected || action.value[0], list: action.value };
    }
    case actionTypes.SET_GAME_CATEGORY: {
      return { ...state, selected: action.selected };
    }
    case actionTypes.SET_GAME_CATEGORIES: {
      return { selected: action.value[0], list: action.value };
    }
    default:
      return state;
  }
}

const loadingGameUrlsInitial = [];

export function loadingGameUrls(state = loadingGameUrlsInitial, action) {
  switch (action.type) {
    case actionTypes.GAME_URL_REQUEST: {
      const { id } = action.value.game;
      return state.indexOf(id) > -1 ? state : [...state, id];
    } 
    case actionTypes.GAME_URL_SUCCESS:
    case actionTypes.GAME_URL_FAIL: {
      const id = action.type === actionTypes.GAME_URL_SUCCESS
        ? action.value.id
        : action.value;
      const position = state.indexOf(id);
      if (position > -1) {
        const newState = [...state];
        newState.splice(position, 1);
        return newState;
      }
      return state;
    } default:
      return state;
  }
}

const gameUrlsInitial = {};

export function gameUrls(state = gameUrlsInitial, action) {
  switch (action.type) {
    case actionTypes.GAME_URL_SUCCESS: {
      const { id, url } = action.value;
      return { ...state, [id]: url };
    } case actionTypes.GAME_URL_FAIL:
    case actionTypes.GAME_URL_REMOVE: {
      const id = action.value;
      if (!(id in state)) return state;
      const newState = { ...state };
      delete newState[id];
      return newState;
    } default:
      return state;
  }
}

const tournamentGameUrlsInitial = {'urlFailed': false};

export function tournamentGameUrls(state = tournamentGameUrlsInitial, action) {
  switch (action.type) {
    case actionTypes.TOURNAMENT_GAME_URL_SUCCESS: {
      const { id, url, size } = action.value;
      const windowSize = (size === undefined || size == 1) ? 'fullScreen' : 'noFullScreen';
      return { ...state, [id]: url, urlFailed: false, size: windowSize };
    } case actionTypes.TOURNAMENT_GAME_URL_FAIL: {
      return {...state, [action.id]: action.message, urlFailed: true}
    }
    case actionTypes.TOURNAMENT_GAME_URL_REMOVE: {
      const id = action.value;
      if (!(id in state)) return state;
      const newState = { ...state };
      delete newState[id];
      return newState;
    }
    default:
      return state;
  }
}

const tournamentChatsInitial = {};

export function tournamentChats(state = tournamentChatsInitial, action) {
  switch (action.type) {
    case actionTypes.TOURNAMENT_CHAT_UPDATE: {
      const { tournamentId } = action.value;
      const messages = tournamentId in state ?
        [...state[tournamentId], action.value].sort((a, b) => a.on - b.on) : 
        [action.value];
      return {
        ...state,
        [tournamentId]: messages,
      };
    } default:
      return state;
  }
};

const tournamentChatIsOpenedInitial = {};

export function tournamentChatStatuses(state = tournamentChatIsOpenedInitial, action) {
  switch (action.type) {
    case actionTypes.OPEN_TOURNAMENT_CHAT:
    case actionTypes.CLOSE_TOURNAMENT_CHAT: {
      const {tournamentId} = action;
      const status = action.type === actionTypes.OPEN_TOURNAMENT_CHAT;
      return {...state, [tournamentId]: status};
    } default:
      return state;
  }
};

const tournamentChatLastViewsInitial = {};

export function tournamentChatLastViews(state = tournamentChatLastViewsInitial, action) {
  switch (action.type) {
    case actionTypes.OPEN_TOURNAMENT_CHAT:
    case actionTypes.CLOSE_TOURNAMENT_CHAT:
    case actionTypes.TOURNAMENT_CHAT_UPDATE: {
      const {tournamentId, now, chatStatus } = action;
      if (!chatStatus) return state;
      return {...state, [tournamentId]: now};
    } default:
      return state;
  }
}